<template>
  <div class="as-match-list">
    <MatchItem
      v-for="(item, key) in rows"
      :key="key"
      :match="parseMatchH2hData(item, homeTeamId)"
      :teams="teams"
      :competitions="competitions"
      :isShowFooter="isShowFooter"
      :isH2h="true"
      session="h2h"
    />

    <div
      v-if="isShowMore == 1"
      @click="handleIsShowMore(mode)"
      class="as-show-more"
    >
      Hiển thị thêm trận đấu <ArrowDown />
    </div>
  </div>
</template>
  <script setup lang="ts">
import { defineProps, computed, ref } from "vue";
import type { IMatch, ITeam, ILeague } from "~src/interfaces/tennis";
import { parseMatchH2hData } from "~src/helpers/tennis";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import MatchItem from "~src/components/matches/tennis/MatchItem.vue";
const emits = defineEmits(["handleIsShowMore"]);
interface IProps {
  h2h: Array<Object>;
  teams: Array<ITeam>;
  competitions: Array<ILeague> | any;
  match: IMatch;
  tab: string;
  isShowFooter: boolean;
  homeTeamId: string;
  isShowMore: number;
  mode: string;
}

const props = withDefaults(defineProps<IProps>(), {
  isShowFooter: true,
  isShowMore: 0,
  mode: "vs",
});

const rows = computed(() => {
  return props.h2h;
});

const handleIsShowMore = (mode: string) => {
  emits("handleIsShowMore", mode);
};
</script>

<script lang="ts">
export default {};
</script>
